// extracted by mini-css-extract-plugin
export var body = "item-module--body--2b935";
export var bound = "item-module--bound--6d841";
export var cate = "item-module--cate--30cd8";
export var image = "item-module--image--63805";
export var img = "item-module--img--6c96e";
export var link = "item-module--link--c09d0";
export var linkInner = "item-module--linkInner--9f17d";
export var meta = "item-module--meta--8a93b";
export var show = "item-module--show--c7966";
export var targetGroup = "item-module--targetGroup--023f2";
export var title = "item-module--title--61d77";